<script setup lang="ts">
interface Props {
  label?: string
  size?: 'sm' | 'md' | 'lg'
  bgColor?: string
  textColor?: string
  icon?: string
}

withDefaults(defineProps<Props>(), {
  label: '',
  size: 'md',
  bgColor: '#E9FBF8',
  textColor: '#0F8F86',
  icon: '',
})
</script>

<template>
    <div class="inline-flex w-fit items-center justify-center font-fa font-medium rounded-[10px]" :class="{
        'gap-1.5 px-3 py-1.5 text-[11px]': size === 'sm',
        'gap-2 px-4 py-2 text-xs': size === 'md',
        'gap-2.5 px-5 py-2.5 text-sm': size === 'lg',
    }" :style="{
        backgroundColor: bgColor,
        color: textColor,
    }">
        <!-- Custom slot -->
        <slot name="icon">
            <img v-if="icon" :src="icon" alt="" class="shrink-0" :class="{
                'w-3.5 h-3.5': size === 'sm',
                'w-4 h-4': size === 'md',
                'w-5 h-5': size === 'lg',
            }" />
        </slot>

        <span v-if="label">
            {{ label }}
        </span>

        <slot />
    </div>
</template>